/*
 * File Created: Tuesday, 16th May 2023 11:39:38 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Theme, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from 'react'

function About() {
  const theme: Theme = useTheme();
  return (
    <Box
      sx={{
        padding: {
          xs: theme.spacing(1.5, 1),
          md: theme.spacing(1.5, 2),
          lg: theme.spacing(1.5, 8),
          xl: theme.spacing(1.5, 20),
        },
      }}
    >
      <Box sx={{...theme.mixins.toolbar}} />
      <div>About</div>
    </Box>
  )
}

export default About